export default {
    cognito: {
        USER_POOL_ID: "eu-central-1_3i0TRTtR1",
        APP_CLIENT_ID: "267nj18u5lo4pnatv2nb367ced",
        REGION: "eu-central-1",
        IDENTITY_POOL_ID: "eu-central-1:e71805f6-f8d7-4e4c-87b8-82d834a08e5f",
    },
    MAX_ATTACHMENT_SIZE: 5000000,
    apiGateway: {
        URL: "https://8mvs4rqewf.execute-api.eu-central-1.amazonaws.com/prod",
        REGION: "eu-central-1"
    },
    jaktaApiGateway: {
        URL: "https://umm560z6o4.execute-api.eu-central-1.amazonaws.com/prod",
        REGION: "eu-central-1"
    },
};


// WEBPACK FOOTER //
// ./src/config.js